<template>
    <div class="ui-card-list-header">
        <div class="ui-card-list-header__title-wrapper">
            <h2 class="ui-card-list-header__title">
                <slot name="title">{{ title }}</slot>
            </h2>
        </div>
        <div v-if="$slots.action || actionHref" class="ui-card-list-header__action">
            <slot name="action">
                <inertia-link
                    v-if="actionHref"
                    :href="actionHref"
                    class="ui-card-list-header__link"
                >
                    <span>{{ actionLabel }}</span>
                    <icon icon="hero/outline/chevron-right" class="size-4" />
                </inertia-link>
            </slot>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    title?: string;
    actionHref?: string;
    actionLabel?: string;
}

withDefaults(defineProps<Props>(), {
    title: '',
    actionHref: '',
    actionLabel: '',
});
</script>
